import { defineMessage } from 'services/localization';

export const messages = {
    startOverDialogTitle: defineMessage('restart_all_currently_running_requests'),
    startOverDialogTitleAfterUpdate: defineMessage('check_if_you_need_to_re_al_of_existing_requests'),
    startOverDialogButtonTitle: defineMessage('restart_the_selected_requests'),
    addCommentPlaceholder: defineMessage('add_a_comment'),
    skipButtonTitle: defineMessage('skip_this_popup'),
    skipButtonText: defineMessage('skip'),
    startOverDialogButton: defineMessage('restart'),
    startOverDialogHintLine1: defineMessage('select_all_requests_tha_l_have_to_make_it_again'),
    startOverDialogHintLine1AfterUpdate1: defineMessage('the_workflow_version_up_val_process_if_required'),
    startOverDialogHintLine2: defineMessage('you_can_leave_a_comment_ers_know_whats_happened'),
    workflowManagerRestart1: defineMessage('the_updated_version_of__ly_affect_new_approvals'),
    workflowManagerRestart2: defineMessage('you_have_currently_coun_approvals_will_be_reset'),
};
